import PropTypes from "prop-types";
import React from "react";

import { FormGroupTitle, FormTextField } from "ui/Form";
import DialogFormWithMutation from "dialogs/DialogFormWithMutation";

import { addFeatureGroupValidator } from "validators/addFeatureGroupValidator";

import {
  ADD_FEATURE_GROUP,
  GET_LICENSE_FEATURE_GROUP_NAME,
} from "graphqlQueries/licenses";

const initialValues = {
  name: "",
  description: "",
};

const fieldsWithPlaceForError = ["name", "description"];

const AddFeatureGroupDialog = (props) => {
  return (
    <DialogFormWithMutation
      mutationQueries={ADD_FEATURE_GROUP}
      refetchQueries={[GET_LICENSE_FEATURE_GROUP_NAME]}
      initialValues={initialValues}
      validationSchema={addFeatureGroupValidator}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="New group"
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <FormGroupTitle title="Group information" />
      <FormTextField name="name" label="Name" />
      <FormTextField name="description" label="Description" />
    </DialogFormWithMutation>
  );
};

AddFeatureGroupDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default AddFeatureGroupDialog;
